/*----- CREATE INITIAL STATE ------*/

import { createSlice } from "@reduxjs/toolkit";
import { defaultApiState } from "../../../common/constants/api-constants";
import { SharpenProductDataState } from "../interfaces/sharpen-state.interface";
import { fetchAllSharpenProducts } from "../thunks/sharpen-search-service-data.thunk";
import { ActionStatus } from "../../../common/constants/action-status";

export const sharpenProductDataInitialState: SharpenProductDataState = {
  selectedSharpenUpsellProductData: undefined,
  sharpenSearchServiceProductData: defaultApiState,
};

/*----- CREATE STORE SLICE ------*/

export const sharpenSearchServiceDataSlice = createSlice({
  name: 'sharpenSearchServiceData',
  initialState: sharpenProductDataInitialState,
  reducers: {
    setSelectedSharpenUpsellData(state, action) {
      state.selectedSharpenUpsellProductData = action.payload;
    },
  },
  extraReducers(builder) {
    builder
      .addCase(fetchAllSharpenProducts.pending, (state) => {
        state.sharpenSearchServiceProductData.status = ActionStatus.loading;
        state.sharpenSearchServiceProductData.data = undefined;
      })
      .addCase(fetchAllSharpenProducts.fulfilled, (state, action) => {
        state.sharpenSearchServiceProductData.status = ActionStatus.succeeded;
        state.sharpenSearchServiceProductData.data = action.payload;
      })
      .addCase(fetchAllSharpenProducts.rejected, (state, action) => {
        state.sharpenSearchServiceProductData.status = ActionStatus.failed;
        state.sharpenSearchServiceProductData.error = action.error.message || '';
      });
    },
  }
);

export const {
  setSelectedSharpenUpsellData,
} = sharpenSearchServiceDataSlice.actions;

/*----- CREATE REDUCER ------*/

export const sharpenSearchServiceDataReducer = sharpenSearchServiceDataSlice.reducer;
